import { useTranslation } from 'react-i18next';
import useScrollReveal from '@/hooks/useScrollReveal';

const reasons = [
  { icon: 'ri-leaf-line', key: 'ingredients', keyDesc: 'ingredients_desc' },
  { icon: 'ri-close-circle-line', key: 'no_preservatives', keyDesc: 'no_preservatives_desc' },
  { icon: 'ri-heart-line', key: 'lactose_free', keyDesc: 'lactose_free_desc' },
  { icon: 'ri-flashlight-line', key: 'protein', keyDesc: 'protein_desc' },
  { icon: 'ri-hand-heart-line', key: 'artisanal', keyDesc: 'artisanal_desc' },
  { icon: 'ri-earth-line', key: 'local', keyDesc: 'local_desc' },
];

export default function WhyChooseSection() {
  const { t } = useTranslation();
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <section id="por-que-elegir" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none overflow-hidden">
        <div className="absolute left-0 bottom-0 opacity-[0.04]">
          <div className="w-64 h-64 border border-primary-400 rounded-full"></div>
          <div className="w-48 h-48 border border-primary-400 rounded-full ml-32 -mt-48"></div>
        </div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-10">
        <div ref={ref} className={`scroll-reveal text-center mb-16 ${isVisible ? 'visible' : ''}`}>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-4">
            {t('why.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((reason, idx) => (
            <div
              key={reason.key}
              className={`scroll-reveal group flex items-start gap-5 p-6 md:p-7 bg-background-50 rounded-2xl border border-background-200/70 transition-all duration-500 hover:-translate-y-1 hover:border-primary-200`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-400">
                <i className={`${reason.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-800 mb-1.5">
                  {t(`why.${reason.key}`)}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {t(`why.${reason.keyDesc}`)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}